import {
  GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR,
  GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  GET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  SET_FLEET_ITEM_RETURN_TO_REQUESTOR,
} from "./FleetItemReturnToRequestorType";

const getFleetItemReturnToRequestor = (payload: any) => ({
  type: GET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  payload,
});

const setFleetItemReturnToRequestor = (fleetItemReturn: any) => ({
  type: SET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  fleetItemReturn,
});

const getAssetFleetItemReturnToRequestor = (payload: any) => ({
  type: GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  payload,
});

const setAssetFleetItemReturnToRequestor = (assetFleetItemReturn: any) => ({
  type: SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR,
  assetFleetItemReturn: assetFleetItemReturn
});

const getAfeFleetItemReturnToRequestor = (payload: any) => ({
  type: GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR,
  payload,
});


export {
  getFleetItemReturnToRequestor,
  setFleetItemReturnToRequestor,
  getAssetFleetItemReturnToRequestor,
  setAssetFleetItemReturnToRequestor,
  getAfeFleetItemReturnToRequestor
};
